import { useState } from 'react';
import classNames from 'classnames';

import {
  SectionTitle,
  TextBlock,
  Button,
  BusinessContactForm,
} from '@/ui/index';
import { ArrowRight } from '@/icons/index';

import Table from './Table';

import styles from './InfoTable.module.scss';

const InfoTable = ({ data, className, dark }) => {
  const [modalActive, setModalActive] = useState(false);

  const closeModal = () => {
    setModalActive(false);
  };

  return (
    <section
      data-testid='info-table'
      className={classNames([
        styles['info-table'],
        className,
        { [styles['info-table--dark']]: dark },
      ])}
    >
      {data?.title && (
        <SectionTitle
          titleModify={classNames(styles['info-table__title'], 'title--large')}
        >
          {data.title}
        </SectionTitle>
      )}
      {data?.description && (
        <TextBlock
          className={classNames(styles['info-table__text'], 'text--large')}
        >
          {data.description}
        </TextBlock>
      )}
      {data?.columns && <Table data={data?.columns} />}
      {data?.button_text && (
        <Button
          className={styles['info-table__button']}
          onClick={() => setModalActive(true)}
        >
          {data?.button_text}
          <ArrowRight width={20} />
        </Button>
      )}
      <BusinessContactForm activeModal={modalActive} clearTariff={closeModal} />
    </section>
  );
};

export default InfoTable;
